"use client";

import { useEffect } from "react";
import {
  APP_MOBILE_NAV_MEDIA_QUERY,
  getWorkspaceChatVisibilityAction,
} from "@/lib/appOverlayPolicy";

const CRISP_SCRIPT_SRC = "https://client.crisp.chat/l.js";
const CRISP_WEBSITE_ID = "137d8c5f-7b93-48c7-a1a5-76728522cb86";

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

export function CrispChat() {
  useEffect(() => {
    window.$crisp = window.$crisp ?? [];
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

    if (document.querySelector(`script[src="${CRISP_SCRIPT_SRC}"]`)) {
      return;
    }

    const script = document.createElement("script");
    script.src = CRISP_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}

function setChatVisibility(mobileNavigationVisible: boolean) {
  window.$crisp = window.$crisp ?? [];
  window.$crisp.push([
    "do",
    getWorkspaceChatVisibilityAction(mobileNavigationVisible),
  ]);
}

export function WorkspaceCrispPolicy() {
  useEffect(() => {
    const mobileNavigation = window.matchMedia(APP_MOBILE_NAV_MEDIA_QUERY);
    const syncVisibility = () => setChatVisibility(mobileNavigation.matches);

    syncVisibility();
    mobileNavigation.addEventListener("change", syncVisibility);

    return () => {
      mobileNavigation.removeEventListener("change", syncVisibility);
      setChatVisibility(false);
    };
  }, []);

  return null;
}
